import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import createWebSocketMiddleware from '@giantmachines/redux-websocket';
import combineReducers from '../reducers';
import { rootSaga } from './rootSaga'; // переконайся, що створив rootSaga

const configureStore = (initialState) => {
  const middlewares = [];

  // Додаємо thunk
  middlewares.push(thunk);

  // Створюємо saga middleware і додаємо його
  const sagaMiddleware = createSagaMiddleware();
  middlewares.push(sagaMiddleware);

  // Створюємо websocket middleware із базовими опціями (налаштуй за потребою)
  const wsMiddleware = createWebSocketMiddleware({
    reconnectInterval: 3000,
    // можна додати додаткові опції, якщо потрібно
  });
  middlewares.push(wsMiddleware);

  const store = createStore(
    combineReducers,
    initialState,
    compose(applyMiddleware(...middlewares)),
  );

  // Запуск rootSaga
  sagaMiddleware.run(rootSaga);

  return store;
};

export default configureStore;
